export function getCategoryParentId(cat) {
  if (!cat) return null;
  const raw = cat.parentCategory ?? cat.parent ?? null;
  if (raw == null) return null;
  if (typeof raw === 'object') {
    const id = raw._id ?? raw.id;
    return id != null ? String(id).trim() : null;
  }
  const s = String(raw).trim();
  return s && s !== 'undefined' && s !== 'null' ? s : null;
}

function findCategoryById(allCategories, id) {
  if (!id) return null;
  const needle = String(id).trim();
  return allCategories.find((c) => String(c._id || c.id).trim() === needle) || null;
}

/**
 * Map API product.category (sometimes sub/child id) to main + sub + child ids for the form.
 */
export function resolveProductCategorySelection(product, allCategories = []) {
  const empty = {
    mainCategoryId: '',
    subcategoryId: '',
    childrenCategoryId: '',
    mainCategoryName: '',
    subcategoryName: '',
  };

  if (!product) return empty;

  let rawCategoryId =
    typeof product.category === 'object'
      ? product.category._id || product.category.id
      : product.category;
  rawCategoryId = rawCategoryId ? String(rawCategoryId).trim() : '';

  let subcategoryId = product.subcategory ? String(product.subcategory).trim() : '';
  let childrenCategoryId = product.childrenCategory
    ? String(product.childrenCategory).trim()
    : '';

  let mainCategoryName =
    (typeof product.category === 'object' && product.category.name) ||
    product.mainCategory ||
    '';

  if (!rawCategoryId || !Array.isArray(allCategories) || allCategories.length === 0) {
    return {
      ...empty,
      mainCategoryId: rawCategoryId,
      subcategoryId,
      childrenCategoryId,
      mainCategoryName: mainCategoryName || '',
    };
  }

  const row = findCategoryById(allCategories, rawCategoryId);
  if (!row) {
    if (subcategoryId && findCategoryById(allCategories, subcategoryId)) {
      return {
        mainCategoryId: rawCategoryId,
        subcategoryId,
        childrenCategoryId,
        mainCategoryName: mainCategoryName || '',
        subcategoryName: '',
      };
    }
    return {
      ...empty,
      mainCategoryId: rawCategoryId,
      subcategoryId,
      childrenCategoryId,
      mainCategoryName: mainCategoryName || '',
    };
  }

  const parentId = getCategoryParentId(row);
  let mainCategoryId = rawCategoryId;

  if (parentId) {
    const parentRow = findCategoryById(allCategories, parentId);
    const grandParentId = parentRow ? getCategoryParentId(parentRow) : null;

    if (grandParentId) {
      mainCategoryId = grandParentId;
      if (!subcategoryId || !findCategoryById(allCategories, subcategoryId)) {
        subcategoryId = parentId;
      }
      childrenCategoryId = rawCategoryId;
    } else {
      mainCategoryId = parentId;
      if (!subcategoryId || !findCategoryById(allCategories, subcategoryId)) {
        subcategoryId = rawCategoryId;
      }
    }
  }

  const mainRow = findCategoryById(allCategories, mainCategoryId);
  if (mainRow?.name) mainCategoryName = mainRow.name;

  const subRow = findCategoryById(allCategories, subcategoryId);
  const subcategoryName = subRow?.name || (subcategoryId && !isMongoObjectId(subcategoryId) ? subcategoryId : '');

  return {
    mainCategoryId,
    subcategoryId,
    childrenCategoryId,
    mainCategoryName: mainCategoryName || '',
    subcategoryName,
  };
}

function isMongoObjectId(value) {
  return /^[a-f0-9]{24}$/i.test(String(value || '').trim());
}

export function mapImagesForProductApi(uploadedImages) {
  if (!Array.isArray(uploadedImages)) return [];
  return uploadedImages
    .filter((img) => img && (img.url || img.cloudinaryUrl))
    .map((img) => ({
      url: img.url || img.cloudinaryUrl,
      public_id: img.public_id || img.publicId || '',
      asset_id: img.asset_id || img.assetId || '',
      width: typeof img.width === 'number' ? img.width : 0,
      height: typeof img.height === 'number' ? img.height : 0,
      format: img.format || 'jpg',
      bytes: typeof img.bytes === 'number' ? img.bytes : 0,
      originalName: img.originalName || img.originalname || 'image',
      uploadedAt: img.uploadedAt || img.uploaded_at || new Date().toISOString(),
      ...(img.linkedColor ? { linkedColor: String(img.linkedColor).trim() } : {}),
      ...(img.isPrimary ? { isPrimary: true } : {}),
    }));
}
